export enum UserType {
    Customer = 0, // the buyer is an individual
    Merchant = 1, // seller
    CustomerLegal = 2, // the buyer is a legal entity
    MerchantIssuer = 3, // seller who issues coupons
}
